export default {
  en: {
    count_label: {
      one: 'Implement count for 1 translation!',
      other: 'Implement count for many translation!',
    },
    snack: {
      generic_error_msg: 'Implement generic error message translation!',
      check_success: 'Implement check success translation!',
      uncheck_success: 'Implement uncheck success translation!',
    },
  },
};
